// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/detent-spring/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const detentSpringEN: PageEntry = {
  id: "post.rastfeder",
  locale: "en",
  slug: "detent-spring",
  seo: {
    title: "Glossary: Detent spring explained simply | Dietz GmbH",
    description: "Detent springs are special springs that are used to fix components in a specific position. Due to their special shape, these springs lock in a predefined latching point and thus of",
  },
  type: "post",
  h1: "Glossary: Detent spring explained simply",
  intro: "Detent springs are special springs that are used to fix components in a specific position. Due to their special shape, these springs lock in a predefined latching point and thus offer stability and security in various mechanical applications. Detent springs are often used in switch mechanisms, latches or other assemblies to ensure clear positioning. The selection of the right detent spring depends on the requirements for holding force, material properties and the design of the overall system. Due to their wide range of applications, detent springs play an important role in mechanical engineering.",
  blocks: [

  ],
};
